import React, {useEffect} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import message from 'framework/modules/message';
import constants from '../../helpers/constants';
import analytics from '../../helpers/analytics';
import {GUEST_CHOICE__16} from '../../helpers/svg-defs';

import './guest-choice-badge.less';

const translationKey = {
    variant_1: 'top.choice',
    variant_2: 'loved.by.guest',
};

let eventFired = false;

const GuestChoice = ({variant}) => {
    const translation = translationKey[variant];

    useEffect(() => {
        if (translation && !eventFired) {
            analytics.trackPicketlineEvent(
                constants.analytics.GUEST_CHOICE_BADGE_PRESENTED,
                {
                    action_location: constants.EDAP_CATEGORIES.CHECKOUT,
                    variant,
                }
            );
            eventFired = true;
        }
    }, []);

    if (!translation) {
        return null;
    }

    const text = message.read(translation);

    return (
        <div className="guest-choice-badge">
            <SVGIcon inline markup={GUEST_CHOICE__16} />
            <span>{text}</span>
        </div>
    );
};

export default GuestChoice;
